import { getFirestore, doc, getDoc } from "firebase/firestore";
import { app } from "../firebase-config.js";
import { WebtoonEditor } from "../components/studio/WebtoonEditor.js";
import { WebnovelStudio } from "../components/studio/webnovel/WebnovelStudio.js";

const db = getFirestore(app);

export const EpisodeEditorPage = async (props) => {
    // 1. Create Container (Neutral base)
    const container = document.createElement('div');
    container.className = "w-full h-screen overflow-hidden relative bg-zinc-950";

    // 2. Extract ID
    let seriesId = null;
    if (typeof props === 'object') {
        seriesId = props.id || props.seriesId;
    }

    // 3. Loading State
    container.innerHTML = `
        <div class="w-full h-full flex items-center justify-center">
            <div class="text-center">
                <span class="material-symbols-outlined text-4xl text-indigo-500 animate-spin">progress_activity</span>
                <p class="text-zinc-500 mt-2 font-mono text-sm">Loading Studio...</p>
            </div>
        </div>
    `;

    // 4. Initialize (Async)
    (async () => {
        const { getAuth } = await import("firebase/auth");
        const auth = getAuth();

        if (!auth.currentUser) {
            await new Promise(r => setTimeout(r, 500));
        }

        if (!auth.currentUser) {
            window.Modal.alert("로그인이 필요합니다.");
            window.router.navigate('/login');
            return;
        }

        if (!seriesId) {
            window.Modal.alert("잘못된 접근입니다 (Series ID 누락).");
            window.router.navigate('/studio');
            return;
        }

        // Load Data
        try {
            const docRef = doc(db, "series", seriesId);
            const docSnap = await getDoc(docRef);

            if (!docSnap.exists()) {
                window.Modal.alert("작품을 찾을 수 없습니다.");
                window.router.navigate('/studio');
                return;
            }

            const data = docSnap.data();
            const isAdmin = window.user?.role === 'admin' || window.user?.isSuperAdmin || auth.currentUser.email === 'hegler.kim@gmail.com';

            if (data.authorId !== auth.currentUser.uid && !isAdmin) {
                window.Modal.alert("편집 권한이 없습니다.");
                window.router.navigate('/studio');
                return;
            }

            // Render Editor
            container.innerHTML = '';

            // [MIGRATION] Fetch Subcollection Data (Source of Truth)
            const { ContentService } = await import("../services/content.service.js");
            // [FIX] Include Hidden (Draft) Episodes for Editor
            const subEpisodes = await ContentService.getEpisodes(seriesId, true);

            if (data.type === 'webtoon') {
                const editor = new WebtoonEditor(container, seriesId, data, subEpisodes);
                editor.render();
            } else if (data.type === 'webnovel' || data.type === 'novel') {
                // [NEW] Use Modular WebnovelStudio
                const studio = new WebnovelStudio(container, seriesId, data, subEpisodes);
                studio.render();
            } else if (data.type === 'davinci') {
                const { DaVinciEditor } = await import("../components/studio/DaVinciEditor.js");
                new DaVinciEditor(container, seriesId, data);
            } else {
                window.Modal.alert(`알 수 없는 작품 타입: ${data.type}`);
                window.router.navigate('/studio');
            }

        } catch (e) {
            console.error("Editor Load Error:", e);
            window.Modal.alert("에디터 로딩 실패: " + e.message);
            window.router.navigate('/studio');
        }
    })();

    return container;
};
